<div class="pace-barcode-scanner">
    <div
        class="pace-barcode-scanner__recognised d-flex flex-wrap gap-1 justify-content-lg-start justify-content-center"
    >
        @for (rec of recognised | keyvalue; track rec.key) {
            <div class="col-12 col-lg-auto">
                <button
                    type="button"
                    class="btn btn-primary"
                    (click)="selectBarcode(rec.value)"
                    [disabled]="!rec.value.matchesPattern"
                    [tooltip]="rec.value.matchesPattern ? '' : mismatchTooltip()"
                    [attr.aria-label]="pickLabel()"
                >
                    {{ rec.value.displayString }}
                    <small>
                        <span class="badge bg-info">{{ rec.value.readResult.format }}</span>
                    </small>
                </button>
            </div>
        }
    </div>

    <div class="position-relative my-2">
        <video #barcodeVideo autoplay playsinline="playsinline" class="w-100"></video>

        @if (displayMessages.length > 0) {
            <ul class="position-absolute top-0 start-0 m-1 bg-light opacity-75 list-group">
                @for (message of displayMessages; track message) {
                    <li class="list-group-item">{{ message }}</li>
                }
            </ul>
        }

        <div class="position-absolute top-0 end-0 my-2 d-flex align-content-center align-items-stretch gap-1">
            <label for="cameraSelect" class="visually-hidden"> {{ chooseWebcamLabel() }}: </label>

            @if (devices?.length > 1) {
                <select
                    id="cameraSelect"
                    class="form-select form-select-sm w-auto bg-white border-0"
                    [title]="chooseWebcamLabel()"
                    [value]="currentDeviceId ?? ''"
                    (change)="changeCamera($event)"
                    aria-label="{{ chooseWebcamLabel() }}"
                >
                    @for (device of devices; track device.device.deviceId) {
                        <option
                            [value]="device.device.deviceId"
                            [selected]="device.device.deviceId === currentDeviceId"
                            [title]="device.device.label"
                        >
                            {{ device.device.label }}
                        </option>
                    }
                </select>
            } @else {
                <div
                    class="text-muted small text-truncate px-2 bg-white rounded-2 d-flex align-items-center"
                    [title]="devices[0]?.device?.label"
                >
                    {{ devices[0]?.device?.label }}
                </div>
            }
            <button
                type="button"
                class="btn btn-secondary bg-white"
                (click)="refocus()"
                [tooltip]="'Click to restart the stream.'"
                [attr.aria-label]="restartStreamLabel()"
            >
                <fa-icon [icon]="refocusIcon" class="pe-1"></fa-icon>
            </button>
        </div>

        @if (pattern()) {
            <button
                type="button"
                class="btn btn-secondary bg-white position-absolute bottom-0 end-0 my-2"
                (click)="toggleShowPattern()"
                [tooltip]="togglePatternLabel()"
                [attr.aria-label]="togglePatternLabel()"
            >
                @if (showPattern) {
                    Expected pattern: <code>{{ pattern() }}</code>
                } @else {
                    <fa-icon [icon]="patternIcon"></fa-icon>
                }
            </button>
        }
        @if (minHeight > 10) {
            <div
                class="position-absolute top-0 start-0 w-100 text-center d-flex flex-column justify-content-center"
                [ngStyle]="{ 'min-height': minHeight + 'px' }"
            >
                Stream is restarting....
                <progressbar [value]="100" [animate]="true"></progressbar>
            </div>
        } @else {
            <div class="pace-barcode-scanner__aim-hair"></div>
        }
    </div>
</div>
